<template>
  <div class="household-details">
    <InfoBox class="info-box" :content="content" />
    <LoadSpinner v-if="loading" />
    <div v-else class="survey-container">
      <h4 class="header">{{ displayName }}</h4>
      <SurveyResponseComponent @survey-done="onSurveyDone" :surveyResponse="surveyResponse" />
    </div>
  </div>
</template>

<script>
import SurveyResponse from '@/services/surveyresponses'
import SurveyResponseComponent from '@/components/SurveyResponse'
import { mapState } from 'vuex'
import LoadSpinner from '@/components/LoadSpinner'
import InfoBox from '@/components/InfoBox'

export default {
  name: 'HouseholdDetailsRequest',
  components: {
    InfoBox,
    SurveyResponseComponent,
    LoadSpinner,
  },
  data() {
    return {
      loading: null,
      surveyResponse: null,
      displayName: this.$gettext('Personal Information (2 of 2)'),
      surveyName: 'Household Details',
      content: this.$gettext(
        'To complete your Grant Circle profile, answer the questions below. The following information is requested for reporting purposes and does not impact your eligibility for a grant.',
      ),
    }
  },
  async created() {
    this.loading = true
    const isComplete = await SurveyResponse.checkIfEmployeeHasCompleted(this.user, this.surveyName)

    if (isComplete && this.organizationDetails.isFinancialHealthSurveyEnabled) {
      return this.$router.push({ name: 'FinancialHealthRequest' })
    }

    if (isComplete && !this.organizationDetails.isFinancialHealthSurveyEnabled) {
      return this.$router.push({ name: 'PayPalVerify' })
    }

    // Otherwise, pull in a survey for them to complete
    const surveyResponse = await SurveyResponse.getOrCreate(this.user, this.surveyName)
    this.surveyResponse = surveyResponse
    this.loading = false
  },
  methods: {
    onSurveyDone(success) {
      if (success && this.organizationDetails.isFinancialHealthSurveyEnabled) {
        return this.$router.push({ name: 'FinancialHealthRequest' })
      }

      if (success && !this.organizationDetails.isFinancialHealthSurveyEnabled) {
        return this.$router.push({ name: 'PayPalVerify' })
      }

      this.$Alert.alert({
        type: 'error',
        message: `<h4>Something went wrong!</h4><p>Please try again later.</p>`,
        timeout: 6000,
      })
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.household-details {
  @include screen-container();
  justify-content: flex-start;
}
.survey-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header {
  font-weight: 600;
  margin: 1rem 0 2rem 0;
}
.skip {
  font-size: 1.2rem;
  font-family: 'Poppins-Medium';
  color: var(--dark-brand-color);
}
</style>
